import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./TimeDropdown.module.scss";

// 30분 단위 시간 옵션 생성 (00:00 ~ 24:00)
const TIME_OPTIONS = [];
for (let h = 0; h <= 24; h++) {
  if (h === 24) {
    TIME_OPTIONS.push("24:00");
  } else {
    TIME_OPTIONS.push(`${String(h).padStart(2, "0")}:00`);
    TIME_OPTIONS.push(`${String(h).padStart(2, "0")}:30`);
  }
}

function TimeDropdown({ value, onChange, disabledTime }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const listRef = useRef(null);

  const toggle = useCallback(() => setOpen((p) => !p), []);

  const handleSelect = useCallback(
    (time) => {
      onChange?.(time);
      setOpen(false);
    },
    [onChange]
  );

  // 외부 클릭 시 닫기
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  // 열릴 때 선택된 항목으로 스크롤
  useEffect(() => {
    if (!open || !listRef.current) return;
    const selected = listRef.current.querySelector(`.${styles.selected}`);
    if (selected) selected.scrollIntoView({ block: "center" });
  }, [open]);

  return (
    <div className={styles.wrap} ref={wrapRef}>
      <button type="button" className={`${styles.trigger} ${open ? styles.triggerActive : ""}`} onClick={toggle}>
        <span className={styles.triggerText}>{value}</span>
        <svg className={styles.chevron} width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M7 9L11 13L15 9" stroke="#171719" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.22" />
        </svg>
      </button>
      {open && (
        <div className={styles.dropdown} ref={listRef}>
          {TIME_OPTIONS.map((time) => {
            const isDisabled = disabledTime && time === disabledTime;
            return (
              <button
                key={time}
                type="button"
                className={`${styles.option} ${time === value ? styles.selected : ""} ${isDisabled ? styles.disabled : ""}`}
                onClick={() => !isDisabled && handleSelect(time)}
                disabled={isDisabled}
              >
                {time}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default TimeDropdown;
